module.exports = __webpack_public_path__ + "img/section-3-m.9424a8c.webp";